const app = {
  state: {
    // 控制大背景的边框北京线是否显示
    isShowbg: true,
    // 存储博罗h5大数据报告选择的日期
    selectDate: {},
    //控制预警弹框是否显示
    isShowWarningBox: true,
    warningId: ""
  },

  mutations: {
    setIsShowbg(state, val) {
        state.isShowbg = val
    },
    setSelectDate(state, val) {  //点击确定按钮时调用
        state.selectDate = val;  //赋值时间
    }
  },

  actions: {
    submitIsShowbg({ commit }, val) {
        console.log(val,'submitIsShowbg======')
        commit('setIsShowbg', val)
    }
  }
}

export default app
